import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/SectionHeading";
import { SECTORS } from "@/lib/content";

function SectorCard({ s, className = "" }) {
  return (
    <Reveal className={className}>
      <Link
        to={`/acquisitions/${s.slug}`}
        data-testid={`sector-card-${s.slug}`}
        className="group relative block h-full overflow-hidden rounded-2xl border border-white/10 card-lux"
      >
        <div className="absolute inset-0">
          <img src={s.img} alt={s.title} loading="lazy" className="img-duotone h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07080B] via-[#07080B]/55 to-transparent" />
        </div>
        <div className="relative h-full flex flex-col justify-between p-6">
          <div className="flex items-center justify-between">
            <span className="font-mono text-xs tracking-widest text-gold">{s.n}</span>
            <ArrowUpRight className="h-5 w-5 text-white/50 transition-all duration-300 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </div>
          <div>
            <h3 className="font-serif text-2xl sm:text-3xl text-white leading-tight">{s.title}</h3>
            <p className="mt-2 text-sm text-slate-300/90 font-light max-w-md">{s.short}</p>
          </div>
        </div>
      </Link>
    </Reveal>
  );
}

export function Sectors() {
  return (
    <section className="relative py-28 sm:py-36 bg-[#0B0D13]" data-testid="sectors">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <SectionHeading
            eyebrow="Nos secteurs d'acquisition"
            lines={["Neuf familles de métiers", "techniques complémentaires."]}
          />
          <Reveal>
            <div className="flex items-center gap-3 text-sm text-[var(--txt-2)]">
              <span className="eyebrow !text-slate-400">Zone d'acquisition</span>
              <span className="font-serif text-2xl text-white">France 🇫🇷 + Suisse 🇨🇭</span>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-flow-dense grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-[300px]">
          {SECTORS.map((s, i) => (
            <SectorCard
              key={s.slug}
              s={s}
              className={i === 0 ? "sm:col-span-2 lg:row-span-2" : i === 8 ? "sm:col-span-2 lg:col-span-3" : ""}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
